import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown, Nav, Navbar } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/header.css';

function Header() {
  const { t, i18n } = useTranslation();

  // Function to switch language
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <Navbar expand="lg">
      <div className="container">
        <Link className="navbar-brand" to="/">{t('portfolio')}</Link>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav" style={{ justifyContent: 'space-between' }}>
          <Nav className="mr-auto">
            <Link className="nav-link" to="/">{t('photos')}</Link>
            <Link className="nav-link" to="/aboutme">{t('aboutme')}</Link>
          </Nav>
          <Nav className="ml-auto">
            <Dropdown className="language-dropdown">
              <Dropdown.Toggle id="dropdown-basic">
                🌐
              </Dropdown.Toggle>
              <Dropdown.Menu align="right">
                <Dropdown.Item onClick={() => changeLanguage('en')}>
                  🇬🇧 English
                </Dropdown.Item>
                <Dropdown.Item onClick={() => changeLanguage('pt')}>
                  🇵🇹 Portuguese
                </Dropdown.Item>
                <Dropdown.Item onClick={() => changeLanguage('es')}>
                  🇪🇸 Spanish
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default Header;
